
import api from "./api";


export const getMeetingPR = async (roomId, oldprId = null) => {
  return api.post(`advisor/getMeetingPR`, {
    client_id: roomId,
    prf: oldprId
  });
};